<template>
    <loginForm />
</template>

<script>
export default {
    components: {
    'loginForm': require('@/components/LoginForm.vue').default
    }
}
</script>
